<template>
  <el-table-column
    prop="invoice.id"
    sortable="custom"
    label="Előlegszámla"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.invoices && scope.row.invoices.length"
        style="display: inline-block;"
      >
        <receipt-link
          style="display: block"
          v-for="invoice in scope.row.invoices"
          v-if="invoice.invoice_number"
          :id="invoice.id"
          :label="invoice.invoice_number"
          type="invoice"
        />
        <div v-else>Nem véglegesített: {{ `#${invoice.id}` }}</div>
      </div>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó számla</el-tag>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: {
    ReceiptLink,
  },
  propName: 'invoice.id',
};
</script>
